import { Link, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { RawsterBrand } from "./RawsterBrand";
import "./rawster.css";

const RAWSTER_SUPPORT_EMAIL = "Rawster.Info@gmail.com";

export { RAWSTER_SUPPORT_EMAIL };

export function RawsterLayout() {
  const location = useLocation();

  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content") ?? "";
    if (meta) {
      meta.setAttribute(
        "content",
        "Rawster, modern dating and self awareness. Private connection tracking, pulses, and relationship insights."
      );
    }
    return () => {
      if (meta && previousDescription) {
        meta.setAttribute("content", previousDescription);
      }
    };
  }, []);

  useEffect(() => {
    const base = "Rawster";
    const titles: Record<string, string> = {
      "/rawster": base,
      "/rawster/privacy-policy": `Privacy Policy, ${base}`,
      "/rawster/terms": `Terms of Use, ${base}`,
      "/rawster/support": `Support, ${base}`,
    };
    document.title = titles[location.pathname] ?? base;
  }, [location.pathname]);

  return (
    <div className="rawster-page">
      <header className="rawster-header">
        <Link to="/rawster" className="rawster-logo">
          <RawsterBrand />
        </Link>
        <nav className="rawster-nav" aria-label="Rawster legal and support">
          <Link to="/rawster/privacy-policy">Privacy Policy</Link>
          <Link to="/rawster/terms">Terms</Link>
          <Link to="/rawster/support">Support</Link>
        </nav>
      </header>

      <Outlet />

      <footer className="rawster-footer">
        <div className="rawster-footer-inner">
          <RawsterBrand className="rawster-footer-brand" />
          <div className="rawster-footer-links">
            <Link to="/rawster/privacy-policy">Privacy Policy</Link>
            <Link to="/rawster/terms">Terms of Use</Link>
            <Link to="/rawster/support">Support</Link>
          </div>
          <p className="rawster-footer-copy">
            © {new Date().getFullYear()} Rawster. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
